<template>
  <div>
    <air-table
      ref="airTable"
      class="table-v2"
      :show-checkbox="false"
      :show-seq="false"
      :show-operation="false"
      :columns="columns"
      :tree-config="{children: 'children'}"
      :data="getTableData"
      small-empty
    >
    </air-table>
    <div class="informations">
      <div class="information-item">
        <div class="title">{{ $t('notes') }}</div>
        <div class="color-primary">{{ $t('mattersTip') }}</div>
        <div class="color-primary">{{ $t('upperLimitOfTaxExemptionTip') }}</div>
      </div>
      <div class="information-item">
        <div class="title">{{ $t('relatedPolicyLinks') }}</div>
        <div>
          <a class="link" :href="item.policyLink" target="_blank" v-for="item in getLinks" :key="item.id">《{{ item.policyName }}》</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SocialSecurityProvidentFundPolicy",
    props: {
      datas: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        columns: [],
        data: []
      }
    },
    created() {
      this.getColumns();
    },
    methods: {
      getColumns() {
        let columns = [
          { title: this.$t('year'), field: 'year', minWidth: 120, align: 'center', fixed: 'left'},
          {
            title: this.$t('socialSecurity'), align: 'center', isGroup: true,
            children: [
              { title: this.$t('effectiveDate'), field: 'startDateShebao', minWidth: 120, align: 'center' },
              { title: this.$t('expiryDate'), field: 'endDateShebao', minWidth: 120, align: 'center' },
              { title: this.$t('upperLimitOfPensionTaxExemption'), field: 'upperLimitPension', minWidth: 120, align: 'center', money: true },
              { title: this.$t('upperLimitOfMedicalTaxExemption'), field: 'upperLimitMedical', minWidth: 120, align: 'center', money: true },
              { title: this.$t('upperLimitOfUnemploymentTaxExemption'), field: 'upperLimitUnemployment', minWidth: 120, align: 'center', money: true }
            ]
          },
          {
            title: this.$t('providentFund'), align: 'center', isGroup: true,
            children: [
              { title: this.$t('effectiveDate'), field: 'startDate', minWidth: 120, align: 'center' },
              { title: this.$t('expiryDate'), field: 'endDate', minWidth: 120, align: 'center' },
              { title: this.$t('upperLimitOfTaxExemption'), field: 'upperLimitFund', minWidth: 120, align: 'center', money: true }
            ]
          }
        ];
        this.columns = columns;
      },
    },
    computed: {
      getLinks() {
        const { policyLink } = this.datas;
        return policyLink || [];
      },
      getTableData() {
        const tableData = [];
        const { shebao, gongjijin } = this.datas;
        let obj = {}
        if (shebao && shebao.length) {
          shebao.forEach(item => {
            if (!obj[item.year]) {
              const itemObj = {
                ...item,
                startDateShebao: item.startDate,
                endDateShebao: item.endDate
              }
              delete itemObj.startDate;
              delete itemObj.endDate;
              obj[item.year] = itemObj;
            }
          })
        }
        if (gongjijin && gongjijin.length) {
          gongjijin.forEach(item => {
            if (!obj[item.year]) {
              obj[item.year] = {
                ...item
              }
            } else {
              obj[item.year] = {
                ...obj[item.year],
                ...item
              }
            }
          })
        }
        Object.keys(obj).forEach(item => {
          tableData.push(obj[item]);
        })
        return tableData;
      }
    }
  }
</script>

<style scoped>

</style>
